import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { ToggleButton } from './CategoryGoals.styles';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { GoalCard } from '../../../GoalCard/GoalCard';
import { GoalDTO } from '../../../../../api/useResultsQuery';

interface CategoryGoalsProps {
  clientId: string;
  categoryId: string;
  goals: GoalDTO[];
  isTopCategory?: boolean;
  isManagingGoals: boolean;
  canAddGoals: boolean;
  onAddGoal?(): void;
  onManageGoals(): void;
}

export const CategoryGoals = ({
  clientId,
  categoryId,
  goals,
  isTopCategory,
  isManagingGoals,
  onManageGoals,
  onAddGoal,
  canAddGoals,
}: CategoryGoalsProps) => {
  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb="16" css="gap: 4px">
        <ToggleButton
          variant="subtleActive"
          leftIcon={isManagingGoals ? 'far fa-times-circle' : 'far fa-pencil'}
          onClick={onManageGoals}
          aria-pressed={isManagingGoals}
        >
          {isManagingGoals ? 'Exit ' : ''}Manage Goals
        </ToggleButton>

        {isTopCategory && onAddGoal && (
          <Button
            variant="subtleActive"
            leftIcon="fa fa-plus"
            onClick={onAddGoal}
            disabled={!canAddGoals}
          >
            Add Another Goal
          </Button>
        )}
      </Box>

      <Box display="flex" flexDirection="column" css="gap: 16px">
        {goals.map(goal => (
          <GoalCard
            key={goal.id}
            clientId={clientId}
            goal={goal}
            isEditing={isManagingGoals}
            categoryId={categoryId}
          />
        ))}
      </Box>
    </Box>
  );
};
